<template>
  <div>
    <van-address-list v-model="chosenAddressId" :list="list" default-tag-text="默认"
      @add="onAdd" @edit="onEdit" @select="select2back" />
  </div>
</template>

<script>
import { getAddressList, mall_WxUser_save_address } from "@/api/user"
import store from '@/store/index'
import { mall_wx_get_user_info } from "../../../api/login"

export default {
  name: "address",

  data() {
    return {
      chosenAddressId: 0,
      list: [],
    }
  },

  created() {
    mall_wx_get_user_info().then(() => {
      getAddressList().then(res => {
        this.list = res.data.map((item, idx) => {
          return {
            id: item.addressId,
            name: item.name,
            cityCode: item.cityCode,
            cityName: item.cityName,
            tel: item.mobile,
            addressDetail: item.address,
            address: item.cityName + item.address,
            areaCode: item.cityCode,
            isDefault: item.isDefault === 1
          }
        })
      })
    })
  },

  methods: {
    select2back(e) {
      budo_log.info("#69 select2back", e)

      var that = this.list.filter(each => each.id == e.id)[0]

      mall_WxUser_save_address({
        addressId: that.id,
        name: that.name,
        cityCode: that.areaCode,
        cityName: that.cityName,
        address: that.addressDetail,
        mobile: that.tel,
        isDefault: 1
      }).then(res => {
        store.commit('SET_DEFAULT_ADDRESS', {
          addressId: that.id,
          name: that.name,
          cityCode: that.areaCode,
          cityName: that.cityName,
          address: that.addressDetail,
          mobile: that.tel,
          isDefault: 1
        });

        this.$store.dispatch("GetDefaultAddress").then(() => {
          this.$router.go(-1)
        });
      })
    },

    onAdd() {
      this.$router.push({ path: '/user-center-address-edit' })
    },

    onEdit(item, index) {
      budo_log.info("#113", item)
      this.$router.push({ path: '/user-center-address-edit', query: { addressId: item.id } })
    },
  }
}
</script>

<style scoped></style>
